export const GET_EVENTS_REQUEST = 'GET_EVENTS_REQUEST';
export const GET_EVENTS_FAILURE = 'GET_EVENTS_FAILURE';
export const GET_EVENTS_SUCCESS = 'GET_EVENTS_SUCCESS';



// WEBPACK FOOTER //
// ./src/timeline/types.js